import React from 'react';
import { useTranslation } from '~/shared/utils/translation';
import useCustomer from '~/features/commerce-api/hooks/useCustomer';
import { useProfile } from '~/templates/pages/components/P125MyProfilePage/context/ProfileContext';
import { useUtils } from '~/shared/hooks/useUtils';
import Typography from '~/shared/components/Typography/Typography';
import { Button } from '~/shared/components';
import Link from 'next/link';
import styles from './BonusBalance.module.scss';

const BonusBalance: React.FC = () => {
    const { translate } = useTranslation();
    const customer = useCustomer();
    const { pageProps } = useProfile();
    const { convertPriceToLocale } = useUtils();

    const bonusPoints = customer.c_bonusAvailablePoints || 0;
    const pointsHeader = pageProps.pointsHeader;
    const buttonLink = pageProps.buttonLink;
    const buttonColor = pageProps.buttonColor;

    // Don't render if no header text is provided
    if (!pointsHeader) {
        return null;
    }

    return (
        <div className={styles.bonusBalanceContainer}>
            <div className={styles.bonusBalanceContent}>
                {pointsHeader && (
                    <Typography variant="title-S" weight="regular" as="p" className={styles.header}>
                        {pointsHeader}
                    </Typography>
                )}

                <Typography
                    variant="title-L"
                    weight="medium"
                    as="p"
                    className={styles.balanceAmount}
                >
                    {convertPriceToLocale(bonusPoints)} {translate('common.currency')}
                </Typography>

                {translate('login.bonusSaldoDescription')?.trim() && (
                    <Typography
                        variant="paragraph-XS"
                        weight="regular"
                        as="p"
                        className={styles.description}
                    >
                        {translate('login.bonusSaldoDescription')}
                    </Typography>
                )}

                {buttonLink?.url && buttonLink?.text && (
                    <div className={styles.buttonWrapper}>
                        <Button
                            as={Link}
                            href={buttonLink.url}
                            title={buttonLink.title || buttonLink.text}
                            variant="alternative"
                            alternativeBackgroundColor={buttonColor ? `#${buttonColor}` : undefined}
                            size="large"
                        >
                            {buttonLink.text}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BonusBalance;
